module.exports = __webpack_public_path__ + "icon_liikunta.7f45eefba9c92dea416a.svg";